import { EAPFeature } from '.';

export const features: EAPFeature[] = [
    {
        id: 'inbox',
        name: 'Inbox',
        description: 'Never miss notifications anymore thanks to the new Inbox',
        descriptionLong: (
            <>
                <p>
                    Notifications deserve a proper place on the main menu so that users can interact with the content
                    immediately. Your manager left a comment on your objective? Take note and reply right away.
                </p>
                <p>
                    Try our clickable prototype for 1:1s and Objectives, and let us know what’s important to you and
                    your employees.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_inboxPage',
        imgSrc: require('./images/inbox.png'),
        hideIfDisabled: true,
    },
    {
        id: 'admin-navigation-refresh',
        name: 'Easy Admin Navigation',
        description: 'We’ll make it easier to reach all admin screens, removing the need for the "Admin Toggle Button"',
        descriptionLong: (
            <p>
                Many customers told us that toggling the navigation from “employee” to “admin” causes too much friction.
                We are removing the toggle, adding administration screens into the feature tabs.
            </p>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_adminNavigationRefresh',
        imgSrc: require('./images/new-admin-navigation.png'),
    },
    {
        id: 'review-outlier-detection',
        name: 'Review Outlier Detection',
        description: 'Spot statistically significant rating patterns across groups in performance reviews',
        descriptionLong: (
            <p>
                When you're managing hundreds of performance reviews, hidden bias can slip through unnoticed. Our new
                Outlier Detection feature automatically surfaces statistically significant rating patterns across groups
                — by location, tenure, gender, team, manager, and more — so you can spot fairness issues in seconds.
                Instead of manually combing through spreadsheets, you'll see exactly where ratings deviate from the
                cycle average and why it matters, backed by data science best practices.
            </p>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_reviewOverviewTableAnomaly',
        imgSrc: require('./images/review-outlier-detection.png'),
    },
];
